// extracted by mini-css-extract-plugin
export default {"SpecialFloorResources_container":"styles_SpecialFloorResources_container__PhbqZ","equipmentChip":"styles_equipmentChip__TE2AG"};